/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profilelinkpromptconnected3Inputs */

const en_profilelinkpromptconnected3 = /** @type {(inputs: Profilelinkpromptconnected3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected profiles: ${i?.count}. They get new requests as notifications on their phone.`)
};

const de_profilelinkpromptconnected3 = /** @type {(inputs: Profilelinkpromptconnected3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verbundene Profile: ${i?.count}. Sie bekommen neue Anfragen als Mitteilung aufs Handy.`)
};

/**
* | output |
* | --- |
* | "Connected profiles: {count}. They get new requests as notifications on their phone." |
*
* @param {Profilelinkpromptconnected3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkpromptconnected3 = /** @type {((inputs: Profilelinkpromptconnected3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkpromptconnected3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkpromptconnected3(inputs)
	return de_profilelinkpromptconnected3(inputs)
});
export { profilelinkpromptconnected3 as "profileLinkPromptConnected" }